<template>
  <div>
  <br />
    <v-layout
      row wrap
    >
      <v-flex
        md12
      >
        <v-card>
          <v-data-table
            :items="rows"
            :pagination="pagination"
            :total-items="totalRows"
            :rows-per-page-items="paginationStrings"
            :headers="headers"
            :loading="loading"
            @update:pagination="$emit('fetch', arguments[0])"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr
                v-if="loading"
              >
                <td colspan="5">
                  <div style="text-align:center;padding:45px;">
                    <v-progress-circular
                      indeterminate
                      size="70"
                      width="7"
                      color="primary"
                      style="margin-bottom: 5px;"
                    />
                    <h4>Loading...</h4>
                  </div>
                </td>
              </tr>
              <tr
                v-else
              >
                <td colspan="5">
                  <div style="text-align:center;padding:45px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No History of Operations</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <slot v-bind:row="props.item"></slot>
              <td>
                <span
                  v-if="props.item.completed_at"
                >
                  <b>Completed at:</b>
                  <br />
                  {{convertToLocal(props.item.completed_at)}}
                </span>
                <span
                  v-else-if="props.item.started_at"
                >
                  <b>Started at:</b>
                  <br />
                  {{convertToLocal(props.item.started_at)}}
                </span>
                <span
                  v-else
                >
                  <b>Requested:</b>
                  <br />
                  {{convertToLocal(props.item.created_at)}}
                </span>
                <br />
                by {{props.item.created_by_name}}
              </td>
              <td
                @click="showIssueDialog(props.item)"
              >
                <BulkOpsProgressBar
                  :item.sync="props.item"
                />
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="showIssues"
      width="800"
    >
      <v-card>
        <v-toolbar
          color="red"
          dark
          dense
          flat
        >
          Issues
        </v-toolbar>
        <v-card-text>
          <v-data-table
            v-if="isErrorJson"
            :items="issues"
            :headers="errorTableHeaders"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>
                  {{props.item.id}}
                </td>
                <td>
                  {{ props.item.error }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <div
            v-else
          >
            {{issues}}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import BulkOpsProgressBar from '@/components/admin/bulkops/BulkOpsProgressBar'

export default {
  name: 'BulkOpsTable',
  props: [ 'rows', 'pagination', 'totalRows', 'headers', 'loading' ],
  components: {
    BulkOpsProgressBar
  },
  data () {
    return {
      paginationStrings: [
        10, 25, 50
      ],
      showIssues: false,
      issues: [],
      errorTableHeaders: [
        {
          text: 'Object ID',
          value: 'id',
          width: 100
        },
        {
          text: 'Error Description',
          value: 'error'
        }
      ],
      isErrorJson: false
    }
  },
  methods: {
    showIssueDialog (item) {
      if (item.issues) {
        try {
          this.issues = JSON.parse(item.issues)
          this.isErrorJson = true
        } catch (e) {
          this.issues = item.issues
          this.isErrorJson = false
        }
        this.showIssues = true
      }
    }
  }
}
</script>
